export default [
    {
        name: 'rut',
        type: 'rut-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Rut',
        },
    },
    {
        name: 'business_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Razón social',
        },
    },
    {
        name: 'alias_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Nombre de Fantasía',
        },
    },
    {
        name: 'is_pyme',
        type: 'checkbox',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'PYME',
        },
    },
]
